import React, { PureComponent } from 'react';
import styled from 'styled-components';

import Image1 from '../../../containers/assets/onboarding-trivia-image1.png';
import Image2 from '../../../containers/assets/trivia-round1.png';
import Image3 from '../../../containers/assets/trivia-round2.png';
import Image4 from '../../../containers/assets/trivia-round3.png';
import Image5 from '../../../containers/assets/trivia-round4.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    font-weight: 500;
    color: #ed716d;
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

class TriviaIntro extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.setMode('basic');
  }

  render() {
    const { stage } = this.props;

    return (
      <Wrapper>
        <Text1>Trivia: {stage === 'welcome' ? 'Warm Up' : `Round ${stage}`}</Text1>
        {stage === 'welcome' && <Text2>It's Time for Trivia</Text2>}
        {stage !== 'welcome' && <Text2>How Prepared Are You</Text2>}
        {stage === 'welcome' && (
          <Text3>
            Before we kick things off, let’s see how well you understand how
            business works. Note: This Trivia and all other Trivia are not graded.
          </Text3>
        )}
        {stage !== 'welcome' && <Text3>It's time for trivia! Let's see how prepared you are for this round.</Text3>}
        {stage === 'welcome' && (
          <Image>
            <img src={Image1} alt="" />
          </Image>
        )}
        {stage === '1' && (
          <Image>
            <img src={Image2} alt="" />
          </Image>
        )}
        {stage === '2' && (
          <Image>
            <img src={Image3} alt="" />
          </Image>
        )}
        {stage === '3' && (
          <Image>
            <img src={Image4} alt="" />
          </Image>
        )}
        {stage === '4' && (
          <Image>
            <img src={Image5} alt="" />
          </Image>
        )}
      </Wrapper>
    );
  }
}

export default TriviaIntro;



// WEBPACK FOOTER //
// ./src/components/onboarding/trivia/Intro.js